import angular from "angular"
import moment from "angular-moment";
import angularUIBootstrap from "angular-ui-bootstrap";
import kalendar from "../../../kalendar/kalendar";
import refundOrder from "../refundOrder/refundOrder";
import orderHistory from "../order-history/order-history";
import core from "../../../core/core.module";
import printedForms from "../printed-forms/printed-forms";

let mod = angular
    .module('ordersList', [angularUIBootstrap, kalendar, moment, refundOrder, orderHistory, core, printedForms])
    .component('ordersList', {
        template: require('./orders-list.html'),
        controller: ['$http', '$uibModal', 'moment', '$scope', '$timeout', '$rootScope', 'Auth', 'Data', '$httpParamSerializer', controller],
        bindings: {
            changeTypes: '<'
        }
    });

function controller($http, $uibModal, moment, $scope, $timeout, $rootScope, Auth, Data, $httpParamSerializer) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.authUser = Auth.user;

        $ctrl.currentPage = 1;
        $ctrl.organization = null;
        $ctrl.user = null;
        $ctrl.status = null;
        $ctrl.calendarOpen = false;
        $ctrl.datesText = null;
        $ctrl.dateRange = {
            start: null,
            end: null
        };
        $ctrl.search = null;
        $ctrl.showOrganizationsFilter = Auth.hasRoles(['owner.senior_supervisor']);
        $ctrl.showUsersFilter = Auth.hasRoles(['owner.senior_supervisor', 'owner.supervisor', 'customer.supervisor']);
        $ctrl.filtersText = '';
        $ctrl.getList();
    };

    $ctrl.changeFilter = function () {
        $timeout(function () {
            $ctrl.currentPage = 1;
            $ctrl.getList();
        }, 500)
    };

    $ctrl.openCalendar = function () {
        if ($ctrl.closeCalendarTimeout) {
            $timeout.cancel($ctrl.closeCalendarTimeout);
        }
        $ctrl.calendarOpen = true;
    };

    $ctrl.setDates = function (dates) {
        let datesStr = moment(dates[0]).format('DD/MM/YY') + ' - ';
        if (dates[1]) {
            datesStr += moment(dates[1]).format('DD/MM/YY');
        }
        $ctrl.datesText = datesStr;
        $ctrl.dateRange.start = dates[0];
        $ctrl.dateRange.end = dates[1];
        $scope.$apply();
        if (dates[0] && dates[1]) {
            $ctrl.closeCalendar();
            $ctrl.changeFilter();
        }
    };

    $ctrl.closeCalendar = function () {
        if ($ctrl.closeCalendarTimeout) {
            $timeout.cancel($ctrl.closeCalendarTimeout);
        }
        $ctrl.closeCalendarTimeout = $timeout(function () {
            $ctrl.calendarOpen = false;
        }, 500);
    };

    $ctrl.clearCalendar = function () {
        $ctrl.dateRange.start = null;
        $ctrl.dateRange.end = null;
        $ctrl.datesText = null;
        $ctrl.closeCalendar();
        $ctrl.changeFilter();
    };

    $ctrl.getOrganizations = function (fragment) {
        return Data.getOrganizations(fragment);
    };

    $ctrl.clearOrganization = function () {
        if ($ctrl.organization === null) {
            $ctrl.getList();
        }
    };

    $ctrl.getUsers = function (fragment) {
        return Data.getUsers(fragment);
    };

    $ctrl.clearUser = function () {
        if ($ctrl.user === null) {
            $ctrl.getList();
        }
    };

    $ctrl.getList = function () {

        let params = {
            organizationId: $ctrl.organization ? $ctrl.organization.id : null,
            userId: $ctrl.user ? $ctrl.user.id : null,
            status: $ctrl.status,
            startDate: $ctrl.dateRange.start,
            endDate: $ctrl.dateRange.end,
            search: $ctrl.search
        };

        $ctrl.filtersText = $httpParamSerializer(params);

        params.currentPage = $ctrl.currentPage;

        $http
            .get('/orders/get-list', {params: params})
            .then(
                function (response) {
                    $ctrl.totalCount = response.data.totalCount;
                    $ctrl.orders = response.data.orders;
                    $timeout(function () {
                        refreshOrders();
                    });
                },
                function (error) {
                }
            );
    };

    function refreshOrders() {
        for (let i = 0; i < $ctrl.orders.length; i++) {
            setCanReturn($ctrl.orders[i]);
        }
    }

    function setCanReturn(order) {

        let canReturn = true;

        if (order.status != 'confirmed') {
            canReturn = false;
        } else if (order.in_process || order.is_returned) {
            canReturn = false;
        } else {
            for (let i = 0; i < order.tickets.length; i++) {
                if (order.tickets[i].is_returned || order.tickets[i].in_return_process) {
                    canReturn = false;
                    break;
                }
            }
        }

        order.canReturn = canReturn;

    }

    $ctrl.refund = function (order, ticket) {
        $uibModal.open({
            component: 'refundOrder',
            windowTemplateUrl: 'refund-modal-popup.html',
            resolve: {
                order: function () {
                    return order;
                },
                ticket: function () {
                    return ticket;
                }
            }
        }).result.then(function (result) {

            if (result.isSend) {

                $timeout(function () {
                    if (ticket) {
                        ticket.in_return_process = true;
                    } else {
                        order.in_process = 'refund';
                    }
                    order.changes.push({
                        type: 'send-to-refund',
                        ticket_number: ticket ? ticket.number : null,
                        user: Auth.user,
                        added_on: new Date(),
                        fail_message: ''
                    });
                });

                $rootScope.$emit('order.changed', {
                    order: order,
                    ticket: ticket,
                    type: 'send-to-refund',
                    type_label: 'Отправлен на возврат',
                    fail_message: null,
                    added_on: new Date(),
                    user: Auth.user,
                    isLocal: true,
                });

                $timeout(function () {
                    setCanReturn(order);
                });
            }

        });
    };

    $ctrl.openHistory = function (order) {
        $uibModal.open({
            component: 'orderHistory',
            resolve: {
                order: function () {
                    return order;
                }
            }
        });
    };

    $ctrl.openPrintedForms = function (order) {
        $uibModal.open({
            component: 'printedForms',
            resolve: {
                order: function () {
                    return order;
                }
            }
        });
    };

    $rootScope.$on('order.changed', function (event, operation) {
        if (operation.isLocal) {
            return true;
        }
        $timeout(function () {
            let order = null;
            for (let i = 0; i < $ctrl.orders.length; i++) {
                if ($ctrl.orders[i].id == operation.order.id) {
                    order = $ctrl.orders[i];
                    break;
                }
            }
            if (order) {
                if (operation.type == 'confirm-success') {
                    order.status = 'confirmed';
                    order.in_process = null;
                }
                if (operation.type == 'cancel') {
                    order.status = 'canceled';
                }
                if (operation.type == 'send-to-refund') {
                    if (operation.ticket) {
                        for (let i = 0; i < order.tickets.length; i++) {
                            if (order.tickets[i].number == operation.ticket.number) {
                                order.tickets[i].in_return_process = true;
                                break;
                            }
                        }
                    } else {
                        order.in_process = 'refund';
                    }
                }
                if (operation.type == 'refund-success') {
                    if (operation.ticket) {
                        for (let i = 0; i < order.tickets.length; i++) {
                            if (order.tickets[i].number == operation.ticket.number) {
                                order.tickets[i].in_return_process = false;
                                order.tickets[i].is_returned = true;
                                break;
                            }
                        }
                    } else {
                        order.in_process = null;
                        order.is_returned = true;
                    }
                }
                if (operation.type == 'refund-reject' || operation.type == 'refund-error') {
                    if (operation.ticket) {
                        for (let i = 0; i < order.tickets.length; i++) {
                            if (order.tickets[i].number == operation.ticket.number) {
                                order.tickets[i].in_return_process = false;
                                break;
                            }
                        }
                    } else {
                        order.in_process = null;
                    }
                }
                order.changes.push({
                    type: operation.type,
                    ticket_number: operation.ticket ? operation.ticket.number : null,
                    user: operation.user,
                    added_on: operation.added_on,
                    fail_message: operation.fail_message
                });
                setCanReturn(order);
            }
        });

    });

    $rootScope.$on('activeOrders.sentToConfirm', function (event, data) {
        let order = null;
        for (let i = 0; i < $ctrl.orders.length; i++) {
            if ($ctrl.orders[i].id == data.orderId) {
                order = $ctrl.orders[i];
                break;
            }
        }
        if (order){
            $timeout(function () {
                order.in_process = 'confirm';
                order.changes.push({
                    type: 'send-to-confirm',
                    ticket_number: null,
                    user: Auth.user,
                    added_on: new Date(),
                    fail_message: ''
                });
                setCanReturn(order);
            });
        }
    });

    $rootScope.$on('activeOrders.canceled', function (event, data) {
        let order = null;
        for (let i = 0; i < $ctrl.orders.length; i++) {
            if ($ctrl.orders[i].id == data.orderId) {
                order = $ctrl.orders[i];
                break;
            }
        }
        if (order) {
            $timeout(function () {
                order.status = 'canceled';
                order.changes.push({
                    type: 'cancel',
                    ticket_number: null,
                    user: Auth.user,
                    added_on: new Date(),
                    fail_message: ''
                });
                setCanReturn(order);
            });
        }
    });

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/orders/components/orders-list/orders-list.js